import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { type Icon } from '../icon';

let index = 0;

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'sb-tab',
  exportAs: 'sbTab',
  template: '<ng-template><ng-content></ng-content></ng-template>',
})
export class TabComponent {
  @Input({ required: true })
  title!: string;

  icon = input<Icon>();

  @Input({ transform: booleanAttribute })
  disabled = false;

  @ViewChild(TemplateRef, { static: true })
  template!: TemplateRef<HTMLElement>;

  @Output()
  selected = new EventEmitter<void>();

  @Input()
  set id(value: string) {
    if (!value || value === this._id) {
      return;
    }
    this._id = value;
  }
  get id(): string {
    return this._id;
  }

  private _id = `sb-tab-${index++}`;

  get tabLabelId(): string {
    return `${this.id}-label`;
  }

  get tabContentId(): string {
    return `${this.id}-content`;
  }
}
